<template lang="pug">
  div.d-flex
    div.mr-5(style="width: 200px")
      v-autocomplete(
        ref="refCountry"
        return-object
        v-model="country"
        label="Pays"
        filled
        item-value="mask"
        item-text="name_en"
        :items="items"
        :disabled="$attrs.disabled")
    div(style="width: 100%")
      v-text-field(
        type="tel"
        ref="refPhoneNumber"
        autocomplete="tel"
        v-model="phoneNumber"
        :disabled="!country || $attrs.disabled"
        v-mask="mask"
        :hint="mask"
        hint-persistent
        label="Numéro de téléphone"
        v-bind="$attrs"
        :rules="rules"
        filled)
</template>

<script>
import formats from './formats'
import { reactive, toRefs, ref, watch, onMounted, computed } from '@vue/composition-api'
import { mask } from 'vue-the-mask'
import Vue from 'vue'

export default {
  directives: {
    mask
  },

  props: {
    value: String,
    rules: Array
  },

  setup (props, { emit }) {
    const refCountry = ref(null)
    const refPhoneNumber = ref(null)

    const formatToRaw = input =>
      input
        .replace(/ *\([^)]*\) */g, '')
        .replace(/ |\(|\)/g, '')

    const state = reactive({
      _country: formats.find(({ name_en }) => name_en === `France`),
      country: computed({
        get: () => state._country,
        set: country => {
          state._country = country
          refCountry.value.blur()
          refPhoneNumber.value.focus()
        }
      }),

      mask: computed(() => state.country ? state.country.mask : undefined),

      _phoneNumber: ``,
      phoneNumber: computed({
        get: () => state._phoneNumber,
        set: phoneNumber => {
          if (phoneNumber.length <= state.mask.length) {
            state._phoneNumber = phoneNumber
            if (phoneNumber.length === state.mask.length) {
              state.model = phoneNumber
            } else {
              state.model = ''
            }
          }
        }
      }),

      model: computed({
        get: () => props.value,
        set: value => {
          emit(
            'input',
            formatToRaw(value)
          )
        }
      })
    })

    watch(
      () => props.value,
      (value, old) => {
        const valueToSet = value ?? ``

        if (value === null && state.old) { // allows reset if value is null
          state.phoneNumber = ''
        } else if (formatToRaw(state._phoneNumber) !== valueToSet && value !== ``) { // allows set but no reset if new value is not ``
          state.phoneNumber = valueToSet
          Vue.nextTick(() => {
            refPhoneNumber.value.$el.querySelector(`input`).oninput({ isTrusted: true })
          })
        }
      }, {
        immediate: true
      }
    )


    return {
      items: formats,
      refCountry,
      refPhoneNumber,
      ...toRefs(state)
    }
  }
}
</script>
